// extracted by mini-css-extract-plugin
export default {"baseSelect":"styles_baseSelect__mOCtJ","rootBaseSelect":"styles_rootBaseSelect__wlkxc"};